"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = (0, tslib_1.__importStar)(require("react"));
const lib_1 = require("../../lib");
const HeaderStart_1 = require("./HeaderStart");
const HeaderMiddle_1 = require("./HeaderMiddle");
const HeaderEnd_1 = require("./HeaderEnd");
/**
 * Header component
 *
 * @visibleName Header
 */
class Header extends React.Component {
    render() {
        const { children, className } = this.props;
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)(className, (0, lib_1.bem)("header")) }, { children: children }), void 0));
    }
}
exports.Header = Header;
Header.Start = HeaderStart_1.HeaderStart;
Header.Middle = HeaderMiddle_1.HeaderMiddle;
Header.End = HeaderEnd_1.HeaderEnd;
//# sourceMappingURL=Header.js.map